module.exports = __webpack_public_path__ + "static/media/purra_vittamin_eventpop1200x628.9a7f641e.jpg";